import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/tiffin-seva/applications";

export const Route = createFileRoute("/admin/tiffin-seva/applications")({
  component: Page,
});
